export interface AppDeployer {
    run(): Promise<any>;
}